<template>
  <ZMainPage type="card" :loading="loading">
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
    <div v-if="list1.length" class="z-box-bg mb-2">
      <LineWrapper list min="320" label-width="170rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span class="mr-1" v-if="item.value">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="imageVisible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div v-if="list2.length" class="q-box mb-2">
      <div class="q-line hd">
        <div class="t1">题号</div>
        <div class="t2">题目</div>
        <div class="t3">答案</div>
        <div class="t4">得分</div>
      </div>
      <div v-for="item in list2" :key="item.id" class="q-line">
        <div class="t1">{{ item.no }}</div>
        <div class="t2">{{ item.label }}</div>
        <div class="t3">{{ item.value }}</div>
        <div class="t4">{{ item.score }}</div>
        </div>
    </div>
    <div v-if="text" class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">学生评语</span>
      </div>
      <div>{{ text }}</div>
    </div>
  </ZMainPage>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import LineItem from '@/components/common/LineItem'
import LineWrapper from '@/components/common/LineWrapper'
import http from '@/api'

export default {
	_config:{'route':{'path':'detail','meta':{'title':'查看'}}},
  components: { Dialog, LineItem, LineWrapper },
  data() {
    return {
      loading: false,
      list1: [],
      list2: [],
      text: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      http({ url: '/teacher/moral-stu-evaluation/get-evaluation-detail', pre: 'api2' }, { id: this.$route.query.id }).then(res => {
        const list1 = [
          { label: '学生姓名', value: res.student_name },
          { label: '学号', value: res.student_no },
					{ label: '辅导周期', value: res.day_describe },
					{ label: '分值', value: res.total_score },
          { label: '校区', value: res.school_name },
          { label: '年级', value: res.grade_name },
          { label: '班级', value: res.class_name },
          { label: '提交时间', value: res.created_at }
        ]
        this.list1 = list1
        const list2 = []
        const arr = res.evaluation || []
        arr.forEach((i, j) => {
          list2.push({
            id: j,
            no: i.question_num,
            label: i.question_string,
            value: i.answer_string,
            score: i.answer_score
          })
        })
        this.list2 = list2
        this.text = res.stu_evaluation || '-'
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang='scss' scoped>
.q-box {
  background: #fff;
  border-radius: 4rem;
}
.q-line {
  display: flex;
  min-height: 48rem;
  &:not(:last-child) { border-bottom: 1px solid #EAF0FF; }
  &.hd {
    height: 60rem;
    font-weight: bold;
    color: #1C4EFD;
    background: #E8F3FF;
  }
  .t1 {
    width: 90rem;
  }
  .t2 {
    flex: 1;
  }
  .t3 {
    width: 360rem;
  }
  .t4 {
    width: 90rem;
  }
  > div {
    padding: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &:not(:last-child) { border-right: 1px solid #EAF0FF; }
  }
}
</style>
